


import React, { useEffect } from "react";
import './About.css'

const About = () => {
  const stats = [
    { value: "5 Lakh+", label: "Students Trained", color: "primary" },
    { value: "200+", label: "Centers Across India", color: "success" },
    { value: "9+", label: "Global Partnerships", color: "warning" },
    { value: "100%", label: "Authentic Certification", color: "info" },
  ];

  useEffect(() => {
    if (window.WOW) {
      new window.WOW().init();
    }
  }, []);

  return (
    <section className="py-5 bg-light">
      <div className="container">
        {/* Header with gradient - Added fadeInDown animation */}
        <div className="row text-center mb-5 wow fadeInDown" data-wow-duration="1s">
          <div className="col-lg-8 mx-auto">
            <h1 className="display-4 fw-bold" style={{ color: "#0a2b5c" }}>
              About <span style={{ color: "#e67e22" }}>CAD DESK</span>
            </h1>
            <div className="w-25 mx-auto bg-warning" style={{ height: "3px" }}></div>
          </div>
        </div>

        {/* Main content: image + description */}
        <div className="row align-items-center g-5 mb-5">
          <div className="col-md-6 wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s">
            <img
              src="img/cadAbout.avif"
              alt="CAD DESK training session"
              className="img-fluid rounded-4 shadow-lg"
            />
          </div>
          <div className="col-md-6 wow fadeInRight" data-wow-duration="1s" data-wow-delay="0.3s">
            <h2 className="fw-semibold mb-3 mt-3">India's Leading CAD / CAM / CAE Training Institute</h2>
            <p className=" text-secondary">
              CAD DESK is the leading software training institute in India,
              offering a vast range of courses in CAD, CAM, and CAE. More than{" "}
              <strong>5 lakh students</strong> believe in CAD DESK and are
              satisfied with their career growth.
            </p>
            <p className="text-secondary">
              We are the <strong>Authorized Training Partner</strong> of
              Autodesk, PTC, Bentley Systems, and Dassault Systèmes. In a very
              short span, CAD DESK has expanded its network across India and
              now proudly owns more than <strong>200+ centres</strong> throughout
              the country.
            </p>
            <p className="text-secondary">
              Quality education is our motto. Our highly experienced instructors
              focus on the overall development of every student, emphasizing both
              theoretical content and practical knowledge. After course completion,
              students receive a secure and authorized certificate that escalates
              their career and provides great recognition in the industries.
            </p>
             
            {/* Trust badges / partnership logos inline - Added zoomIn animation */}
            <div className="mt-1 d-flex flex-wrap gap-3 wow zoomIn" data-wow-duration="1s" data-wow-delay="0.5s">
              <span className="badge bg-primary rounded-0 px-3 py-2">Autodesk</span>
              <span className="badge bg-success rounded-0 px-3 py-2">PTC</span>
              <span className="badge bg-warning rounded-0 text-white px-3 py-2">Bentley</span>
              <span className="badge bg-info rounded-0 text-white px-3 py-2">Dassault Systèmes</span>
            </div>

            {/* Feature list - Added fadeInUp animation with staggered delays */}
            <div className="d-flex justify-content-start  gap-2 flex-wrap">
              <div className="d-flex align-items-center gap-2 wow fadeInUp" data-wow-delay="0.1s">
                <span className="text-success fs-4">✓</span>
                <span>100% Practical Training</span>
              </div>
              <div className="d-flex align-items-center gap-2 wow fadeInUp" data-wow-delay="0.2s">
                <span className="text-success fs-4">✓</span>
                <span>Expert Instructors</span>
              </div>
              <div className="d-flex align-items-center gap-2 wow fadeInUp" data-wow-delay="0.3s">
                <span className="text-success fs-4">✓</span>
                <span>Placement Assistance</span>
              </div>
            </div>
          </div>
        </div>

        {/* Statistics cards using Bootstrap cards - Added various animations */}
        <div className="row g-4 mb-5">
          {stats.map((stat, index) => (
            <div
              key={index}
              className={`col-sm-4 col-lg-3 mt-2 wow ${
                index === 0 ? 'fadeInUp' : 
                index === 1 ? 'fadeInDown' : 
                index === 2 ? 'zoomIn' : 'flipInY'
              } cursor-pointer`}
              data-wow-duration="1s"
              data-wow-delay={`${index * 0.2}s`}
            >
              <div className="card card-box overflow-hidden rounded-bottom h-100 p-0 w-100 border-0 shadow-md">
                <div className="card-body text-center p-1">
                  <div className={`display-4 fw-bold text-${stat.color} mb-2`}>
                    {stat.value}
                  </div>
                  <p className="card-text text-secondary fs-5 mb-0">
                    {stat.label}
                  </p>
                </div>
                <div className={`card-footer bg-${stat.color} bg-opacity-10 border-0 py-2`}>
                  <small className="text-white fw-semibold">
                    <i className="bi bi-star-fill me-1"></i> Certified
                  </small>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;